import {
  CalendarTask,
  CalendarTaskHeaderGroup,
  CalendarTasksGroup,
} from '@infodata-group/inf-commons';
import { Dayjs } from 'dayjs';

export class CalendarSection {
  section1: CalendarTask[] = [];
  section2: CalendarTask[] = [];

  public startMorning: Dayjs;
  public endMorning: Dayjs;
  public startAfternoon: Dayjs;
  public endAfternoon: Dayjs;

  constructor(
    public nbSection: 1 | 2,
    public group: CalendarTaskHeaderGroup,
    public resource: CalendarTasksGroup,
  ) {}
}
